<template>
  <ProductCellFormList
    type="projects"
    :headers="searchItems"
    :hide-switcher="hideSwitcher"
    :cell-customizations="cellCustomizations"
    :disabled-edit-mode="disabledEditMode"
    :item="item"
    :view="''"
    @saveFileProcess="saveFileProcess"
    v-on="$listeners">
    <v-text-field
      v-model="searchText"
      placeholder="Search by field name..."
      autocomplete="off"
      color="black"
      class="ma-0 pa-4 flex-grow-1 lightGrey bg-lightGrey sourcery__condensed-form search-field"
      clearable
      dense
      flat
      hide-details
      solo />
  </ProductCellFormList>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCellFormList from '@/components/Product/ProductCell/ProductCellProjectsFormList';
import { sortAsideHeadersLast } from '@/utils/productHeaders';

export default {
  name: 'RowDataList',
  components: {
    ProductCellFormList,
  },
  props: {
    disabledEditMode: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
    filterCols: {
      type: Array,
      default: () => [],
    },
    hideSwitcher: {
      type: Boolean,
      default: false,
    },
    cellCustomizations: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    searchText: '',
  }),
  computed: {
    ...mapGetters({
      tableHeaders: 'ScheduleViews/tableHeaders',
    }),
    filteredHeaders() {
      const headersToFilter = (this.headers && this.headers.length > 0)
        ? this.headers
        : this.tableHeaders;

      if (this.filterCols && this.filterCols.length > 0) {
        return headersToFilter.filter(header => this.filterCols.includes(header.value));
      }
      return headersToFilter.filter(header => header.value !== 'order');
    },
    renderHeaders() {
      return this.filteredHeaders.toSorted(sortAsideHeadersLast);
    },
    searchItems() {
      const { renderHeaders, searchText } = this;
      return renderHeaders.filter(item => {
        if (!searchText) return true;
        return item['value'].toLowerCase().includes(searchText.toLowerCase());
      });
    },
  },
  methods: {
    saveFileProcess(e = false) {
      this.$emit('saveFileProcess', e);
    },
  },
};
</script>
